export const DATA = [
    {
        info: {
            title: "Commutatus",
            id: "100",
            name: "Commutatus Name",
            phone_number: "9998989898",
            email_id: "contact@commutatus.com"
        },

        children: [
            {
                info: {
                    title: "CEO",
                    id: "101",
                    name: "Michael Kevin",
                    phone_number: "9988",
                    email_id: "ceo@commutatus.com",
                },

                children: [
                    {
                        info: {
                            title: "Head of Staff/HR",
                            id: "102",
                            name: "Ashish Garg",
                            phone_number: "998877",
                            email_id: "hr@commutatus.com",
                        },

                        children: [
                            {
                                info: {
                                    title: "team",
                                    id: "103"
                                },
                                children: [
                                    {
                                        title: "member",
                                        id: "104",
                                        name: "Sakshi",
                                        phone_number: "5566",
                                        email_id: "sakshi@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "105",
                                        name: "Apurv",
                                        phone_number: "553322",
                                        email_id: "apurv@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "106",
                                        name: "Vishesh",
                                        phone_number: "997788",
                                        email_id: "vishesh@commutatus.com",
                                    },

                                ]
                            },
                            {
                                info: {
                                    title: "team",
                                    id: "107"
                                },
                                children: [
                                    {
                                        title: "member",
                                        id: "108",
                                        name: "Yogesh",
                                        phone_number: "774411",
                                        email_id: "yogesh@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "109",
                                        name: "Kritika",
                                        phone_number: "115596",
                                        email_id: "kritika@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "110",
                                        name: "Surbhi",
                                        phone_number: "116699",
                                        email_id: "surbhi@commutatus.com",
                                    },
                                ]
                            },

                        ]
                    },
                    {
                        info: {
                            title: "Head of Engineering",
                            id: "111",
                            name: "Gurkirpal Singh",
                            phone_number: "889955",
                            email_id: "gurkirpal@commutatus.com",
                        },

                        children: [
                            {
                                info: {
                                    title: "team",
                                    id: "112"
                                },
                                children: [
                                    {
                                        title: "member",
                                        id: "113",
                                        name: "Ashish",
                                        phone_number: "446699",
                                        email_id: "ashish@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "114",
                                        name: "Siddarth",
                                        phone_number: "8811165",
                                        email_id: "siddarth@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "115",
                                        name: "Rohit",
                                        phone_number: "882233",
                                        email_id: "rohit@commutatus.com",
                                    },

                                ]
                            },
                            {
                                info: {
                                    title: "team",
                                    id: "116"
                                },
                                children: [
                                    {
                                        title: "member",
                                        id: "117",
                                        name: "Umang",
                                        phone_number: "885522",
                                        email_id: "umang@commutatus.com",
                                    },
                                    {
                                        title: "Ashish",
                                        id: "118",
                                        name: "Ashish",
                                        phone_number: "664488",
                                        email_id: "shiva@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "119",
                                        name: "Pratik",
                                        phone_number: "771166",
                                        email_id: "pratik@commutatus.com",
                                    },
                                ]
                            },

                        ]
                    },
                    {
                        info: {
                            title: "Head of Design",
                            id: "120",
                            name: "Misha",
                            phone_number: "115599",
                            email_id: "misha@commutatus.com",
                        },

                        children: [
                            {
                                info: {
                                    title: "team",
                                    id: "121"
                                },
                                children: [
                                    {
                                        title: "member",
                                        id: "122",
                                        name: "Deepak",
                                        phone_number: "664488",
                                        email_id: "deepak@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "123",
                                        name: "Abhijat",
                                        phone_number: "772299",
                                        email_id: "abhijat@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "124",
                                        name: "Raunak",
                                        phone_number: "559933",
                                        email_id: "raunak@commutatus.com",
                                    },

                                ]
                            },
                            {
                                info: {
                                    title: "team",
                                    id: "125"
                                },
                                children: [
                                    {
                                        title: "member",
                                        id: "126",
                                        name: "Udit",
                                        phone_number: "449922",
                                        email_id: "udit@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "127",
                                        name: "Virat",
                                        phone_number: "112233",
                                        email_id: "virat@commutatus.com",
                                    },
                                    {
                                        title: "member",
                                        id: "128",
                                        name: "Mayank",
                                        phone_number: "445566",
                                        email_id: "mayank@commutatus.com",
                                    },
                                ]
                            },

                        ]
                    },
                ]
            }
        ]

    }
]